import React, { useState } from "react";
import PropTypes from "prop-types";
import { RCL as useTranslation } from "../RCL";
import { Modal } from "../Modal";
import LayoutWrapper from "../../templates/user-account/components/OktaSignInWidget/LayoutWrapper";

const OktaSigninModal = ({
	language,
	setLoginOpen,
	setUserDismiss,
	isOpenModal,
	isAction,
	customStyles,
}) => {
	const [isOpen, setIsOpen] = useState(isOpenModal);

	return (
		<>
			<Modal
				contentLabel={useTranslation({ searchKey: "okta-widget-modal-label" })}
				container="md"
				overlayClassName={customStyles?.modalOverlay}
				closeClassName={customStyles?.modalClose}
				className={customStyles?.modalContainer}
				isOpen={isOpen}
				isPadding={false}
				onClose={() => {
					setLoginOpen(false);
					setIsOpen(false);
					setUserDismiss(true);
				}}>
				<Modal.Content className={customStyles?.modalContent}>
					<LayoutWrapper
						language={language}
						isAction={isAction}
						setIsOpen={setIsOpen}
						setLoginOpen={setLoginOpen}
						setUserDismiss={setUserDismiss}
					/>
				</Modal.Content>
			</Modal>
		</>
	);
};

OktaSigninModal.propTypes = {
	language: PropTypes.oneOf(["en", "fr"]).isRequired,
	setLoginOpen: PropTypes.func.isRequired,
	setUserDismiss: PropTypes.func.isRequired,
	isOpenModal: PropTypes.bool.isRequired,
	isAction: PropTypes.string.isRequired,
	customStyles: PropTypes.shape({
		modalOverlay: PropTypes.string,
		modalContent: PropTypes.string,
		modalContainer: PropTypes.string,
		modalClose: PropTypes.string,
	}),
};

OktaSigninModal.defaultProps = {
	customStyles: undefined,
};

export default OktaSigninModal;
